export default "__VITE_ASSET__9aFEsaqH__"